<div [ngClass]="{ divider: true, 'divider--loose': loose }">
  <span class="divider__label">
    <ng-content></ng-content>
  </span>
</div>
